import { Fragment, useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import TokenIcon from "@mui/icons-material/Token";
import axios from "axios";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Chip,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import "jspdf-autotable";
import { APIEndpoints } from "../../../redux/constants";
import { getCookie } from "../../../services/cookie";
import DashboardLayout from "../../../layouts/DashboardLayout";
import Status from "../Status";
import CeroButton from "../../../components/CeroButton";

import {
  getReportDetails,
  deleteReport,
  resetReportStatus,
  getCumulativeTopics,
  getReportBlob,
  requestReportNft,
} from "../../../redux/actions";
import { STATUS } from "../../../redux/constants";

import useStyles from "./styles";
import { reportEmissionTypeWIthScopeData } from "../../../constants";
import { rolesEnum } from "../../../layouts/DashboardLayout/pages";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import EmissionPDFExport from "./EmissionPDFExport";
import AssignReport from "./AssignReport";
import ReportAccordion from "./ReportAccordian";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import CeroTable from "../../../components/CeroTable";
import dayjs from "dayjs";
import CeroPopUp from "../../../components/CeroPopUp";
import { object } from "yup";

const ReportDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const [isOpenAssignReport, setOpenAssignReport] = useState(false);
  const role = useSelector((state) => state.auth.role);
  const currentRole = getCookie("role");
  const readOnlyMode = getCookie("read_only_mode") === "disable_edit";
  const countryFacilityData = useSelector(
    (state) => state.listings.getOrganizationCountry.data.country_facility_data
  );
  const [isBlobExist, setIsBlobExist] = useState(false);
  const [avlReports, setAvlReports] = useState([]);
  const [chnReports, setChnReports] = useState([]);
  const [downloadPopUp, setDownloadPopUp] = useState(false);

  const TableColumns = [
    {
      columnKey: "assessment_year",
      columnId: "assessment_year",
      columnHeader: "Assessment Year",
    },
    {
      columnKey: "period",
      columnId: "period",
      columnHeader: "Period",
    },
    {
      columnKey: "program",
      columnId: "program",
      columnHeader: "Program name",
    },
    {
      columnKey: "status",
      columnId: "status",
      columnHeader: "Status",
    },
  ];
  const MaterialityColumns = [
    {
      columnKey: "name",
      columnId: "name",
      columnHeader: "Survey Name",
      width: "40vw",
    },
    {
      columnKey: "created_ts",
      columnId: "created_ts",
      columnHeader: "Date",
      width: "20vw",
    },
    {
      columnKey: "materiality_score",
      columnId: "materiality_score",
      columnHeader: "materiality Score",
      width: "20vw",
      alignContent: "center",
      align: "center",
    },
    {
      columnKey: "materiality_level",
      columnId: "materiality_level",
      columnHeader: "materiality Level",
      width: "20vw",
    },
  ];
  const SupplierColumns = [
    {
      columnKey: "industry_name",
      columnId: "industry_name",
      columnHeader: "Industry Type",
      width: "25vw",
    },
    {
      columnKey: "company_name",
      columnId: "company_name",
      columnHeader: "Company Name",
      width: "25vw",
    },
    {
      columnKey: "survey_date",
      columnId: "survey_date",
      columnHeader: "date",
      width: "25vw",
    },
    {
      columnKey: "total_score",
      columnId: "total_score",
      columnHeader: "Score",
      width: "25vw",
      classes: { column: classes.scorecolumn },
    },
    {
      columnKey: "assessment",
      columnId: "assessment",
      columnHeader: "Assessment Rating",
      width: "25vw",
    },
  ];
  const RiskAssessmentColumns = [
    {
      columnKey: "",
      columnId: "",
      columnHeader: "",
      width: "5vw",
    },
    {
      columnKey: "name",
      columnId: "name",
      columnHeader: "Name",
      width: "25vw",
    },
    {
      columnKey: "email",
      columnId: "email",
      columnHeader: "Email",
      width: "25vw",
    },
    {
      columnKey: "survey_date",
      columnId: "survey_date",
      columnHeader: "date",
      width: "25vw",
    },
    {
      columnKey: "total_score",
      columnId: "total_score",
      columnHeader: "Score",
      width: "25vw",
      classes: { column: classes.scorecolumn },
    },
    {
      columnKey: "assessment",
      columnId: "assessment",
      columnHeader: "Assessment Rating",
      width: "25vw",
    },
  ];
  const handleDrawerClose = () => {
    setOpenAssignReport(false);
  };
  const riskAssessmentData = (assessmentData) => {
    if (!assessmentData) return [];

    const tempData = assessmentData.map((item) => ({
      ...item,
      assessment: (() => {
        if (item.total_score >= 90 && item.total_score <= 100) {
          return (
            <Typography className={classes.excellent}>Excellent</Typography>
          );
        } else if (item.total_score >= 75 && item.total_score < 90) {
          return <Typography className={classes.good}>Very Good</Typography>;
        } else if (item.total_score >= 60 && item.total_score < 75) {
          return <Typography className={classes.moderate}>Good</Typography>;
        } else if (item.total_score >= 40 && item.total_score < 60) {
          return <Typography className={classes.moderate}>Average</Typography>;
        }
        return <Typography className={classes.low}>Poor</Typography>;
      })(),
    }));
    return tempData; // Return the unsorted data if no sorting is applied
  };

  const supplierData = (assessmentData) => {
    if (!assessmentData) return [];

    const tempData = assessmentData.map((item) => ({
      ...item,
      assessment: (() => {
        if (item.total_score >= 90 && item.total_score <= 100) {
          return (
            <Typography className={classes.excellent}>
              Excellent commitment
            </Typography>
          );
        }
        if (item.total_score >= 75 && item.total_score < 90) {
          return (
            <Typography className={classes.good}>Good commitment</Typography>
          );
        }
        if (item.total_score >= 50 && item.total_score < 75) {
          return (
            <Typography className={classes.moderate}>
              Moderate commitment
            </Typography>
          );
        }
        return <Typography className={classes.low}>Low commitment</Typography>;
      })(),
    }));
    return tempData; // Return the unsorted data if no sorting is applied
  };

  const materialityData = (assessmentData) => {
    if (!Array.isArray(assessmentData)) {
      return [];
    }

    return assessmentData?.map((item) => ({
      ...item,
      created_ts: item.created_ts
        ? dayjs(item.created_ts).format("DD/MM/YYYY")
        : "NA",
      materiality_score: `${item.materiality_score}%`,
      materiality_level: (
        <Typography className={classes[item.materiality_level.split(" ")[0]]}>
          {item.materiality_level}
        </Typography>
      ),
    }));
  };

  const getStatus = (status) => {
    if (status === "approved") {
      return <Typography className={classes.approved}>Approved</Typography>;
    } else if (status === "assigned") {
      return (
        <Typography className={classes.assigned}>Pending Approval</Typography>
      );
    } else if (status === "audited") {
      return <Typography className={classes.audited}>Audited</Typography>;
    } else if (status === "review") {
      return <Typography className={classes.review}>Review</Typography>;
    } else if (status === "reported") {
      return <Typography className={classes.reported}>Reported</Typography>;
    } else if (status === "submitted") {
      return (
        <Typography className={classes.submitted}>Pending Approval</Typography>
      );
    } else if (status === "added") {
      return <Typography className={classes.added}>Added</Typography>;
    } else if (status === "verified") {
      return <Typography className={classes.verified}>Verified</Typography>;
    } else if (status === "in_progress") {
      return (
        <Typography className={classes.inprogress}>In Progress</Typography>
      );
    } else if (status.toLowerCase() === "pending_approval") {
      return (
        <Typography className={classes.pending}>Pending Approval</Typography>
      );
    } else {
      return <Typography className={classes.default}>{status}</Typography>;
    }
  };
  const getCarbonOffsetList = () =>
    reportsData.offset_approval_status_list?.map((item) => ({
      ...item,
      status: getStatus(item.status.toLowerCase()),
    }));

  const onSelectCarbonOffsetData = (row) => {
    navigate(`/carbon-offset/${row.program_id}`, {
      state: {
        choosenYear: row.assessment_year,
        choosenPeriod: row.period,
        isFromReport: true,
      },
    });
  };
  const canAbleSeeOffset = !(
    role.includes(rolesEnum.FACILITY_MANAGER) ||
    role.includes(rolesEnum.APPROVER)
  );

  const isSustainabilityManager =
    role.includes(rolesEnum.SUSTAINABILITY_MANAGER) ||
    role.includes(rolesEnum.PROXY_SUSTAINABILITY_MANAGER) ||
    role === "sustainability_manager" ||
    role === "proxy_sustainability_manager";

  const reportDetails = useSelector(
    (state) => state.reports.reportDetails.data
  );

  const selectedYear = reportDetails.year;
  const facilities = reportDetails.facilities;
  const countryFacilityDataObject = {};
  for (const key in countryFacilityData) {
    Object.assign(countryFacilityDataObject, countryFacilityData[key]);
  }

  const reportsListStatus = useSelector(
    (state) => state.reports.reportDetails.status
  );
  const deleteReportStatus = useSelector(
    (state) => state.reports.deleteReport.status
  );

  const reportsData = useSelector(
    (state) => state.reports.getCumulativeTopics.data
  );

  const reportsBlobExist = useSelector(
    (state) => state.reports.getReportBlob.data
  );

  const reportsDataStatus = useSelector(
    (state) => state.reports.getCumulativeTopics.status
  );

  const nftRequestStatus = useSelector(
    (state) => state.reports.requestReportNft.status
  );

  const isAuditor = role === rolesEnum.AUDITOR;
  const onDeleteReport = () => {
    id && dispatch(deleteReport(id));
  };

  const isEmissionsEmpty = reportsData?.emissions?.length === 0;

  const isOffsetEmpty = canAbleSeeOffset
    ? reportsData?.offset_approval_status_list?.length === 0
    : true;

  const isSurveyEmpty = isSustainabilityManager
    ? reportsData?.materiality_survey_result?.length === 0 &&
      reportsData?.supplier_survey_result?.length === 0 &&
      reportsData?.risk_survey_result?.length === 0
    : true;

  const authToken = getCookie("auth_token_admin");
  const requestNFT = () => {
    dispatch(requestReportNft(id));
  };
  const onDownloadReport = async (event) => {
    event.preventDefault();

    try {
      // Fetch the data containing the URLs
      const response = await axios.get(
        `${APIEndpoints.DOWNLOAD_REPORT}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Extract URLs
      const { report_dict } = response.data;
      // const { blob_url, pdf_path } = response.data;

      // Function to download a file
      const downloadFile = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank"; // Open in a new tab to avoid interruptions
        link.download = ""; // Specify a filename if necessary
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      if (typeof report_dict === "object") {
        for (let key in report_dict) {
          if (chnReports.includes(reportMapper[key]))
            await downloadFile(report_dict[key]);
          else if (key === "pdf_report") await downloadFile(report_dict[key]);
          else if (key === "combined_report" && chnReports.includes("ESG"))
            await downloadFile(report_dict["combined_report"]);
        }
      }
      setChnReports([]);
      setDownloadPopUp(false);
    } catch (error) {
      enqueueSnackbar(error?.message || "Failed to download files", {
        variant: "error",
      });
    }
  };

  // Rename old water topics to new ones
  const fixTopics = (topics = []) =>
    topics.map((t) =>
      t === "water_consumption"
        ? "water_supply"
        : t === "water_discharge"
        ? "water_treatment"
        : t
    );

  // Memoize the fixed topics so the array reference is stable
  const emissionTypes = useMemo(
    () => fixTopics(reportDetails.topics || []),
    [reportDetails.topics]
  );

  // A stable string key for the effect dependency (instead of the array itself)
  const emissionTypesKey = useMemo(
    () => emissionTypes.join(","),
    [emissionTypes]
  );

  useEffect(() => {
    if (deleteReportStatus === STATUS.SUCCESS) {
      enqueueSnackbar("Report deleted successfully", { variant: "success" });
      dispatch(resetReportStatus());
      navigate("/reports");
    } else if (deleteReportStatus === STATUS.ERROR) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
      dispatch(resetReportStatus());
    }
  }, [deleteReportStatus, enqueueSnackbar, dispatch, navigate]);

  useEffect(() => {
    if (nftRequestStatus === STATUS.SUCCESS) {
      enqueueSnackbar("NFT reuqested Successfully", { variant: "success" });
      dispatch(resetReportStatus());
    } else if (deleteReportStatus === STATUS.ERROR) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
      dispatch(resetReportStatus());
    }
  }, [nftRequestStatus, enqueueSnackbar, dispatch]);

  const isDeleteLoading = deleteReportStatus === STATUS.RUNNING;
  const data = reportsData?.emissions;
  const filteredData = data?.filter(function (item) {
    return !("sector" in item);
  });
  // const emissionTypes = reportDetails.topics;
  const isaudited = reportDetails.is_audited;

  const typeMap = {
    upstream_t_and_d: "upstream_T&D",
    downstream_t_and_d: "downstream_T&D",
    end_of_life_treatment: "end_of_life_treatment_of_sold_products",
  };

  const onSelectData = (row) => {
    const testdata = row.type || row.id;
    const emisionType = testdata.replace(/ /g, "_");
    navigate(
      `/reports/list-topic/${
        typeMap[emisionType] || emisionType
      }/?year=${selectedYear}&facility=${
        reportDetails.facility_ids
      }&redirect_table=${true}&period=${reportDetails.period}&distribution=${
        row.distribution || ""
      }`
    );
  };

  useEffect(() => {
    if (id) {
      dispatch(getReportDetails(id));
      dispatch(getReportBlob(id));
      const intervalId = setInterval(() => {
        dispatch(getReportBlob(id));
      }, 30000);

      return () => clearInterval(intervalId);
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!selectedYear || !emissionTypes.length) return;
    dispatch(
      getCumulativeTopics(
        emissionTypes,
        selectedYear,
        isAuditor,
        reportDetails?.facility_ids,
        reportDetails?.period,
        reportDetails.country
      )
    );
  }, [
    selectedYear,
    emissionTypesKey, // ← stable dependency (prevents ref loops)
    isAuditor,
    reportDetails?.facility_ids,
    reportDetails?.period,
    reportDetails.country,
    dispatch,
  ]);

  const navigateBack = () => {
    navigate(-1);
  };

  const combustionSummaryColumns = [
    {
      columnKey: "status",
      columnId: "status",
      columnHeader: "Status",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "sector",
      columnId: "sector",
      columnHeader: "Topics",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "total_co2",
      columnId: "total_co2",
      columnHeader: "CO2 (tonnes)",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "total_ch4",
      columnId: "total_ch4",
      columnHeader: "CH4 (tonnes)",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "total_n2o",
      columnId: "total_n2o",
      columnHeader: "N2O (tonnes)",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "total_co2e",
      columnId: "total_co2e",
      columnHeader: "CO2e (tonnes)",
      classes: { column: classes.cellContainer },
    },
  ];

  const waterSummaryColumns = [
    {
      columnKey: "status",
      columnId: "status",
      columnHeader: "Status",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "type",
      columnId: "type",
      columnHeader: "Topics",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "usage",
      columnId: "usage",
      columnHeader: "Usage",
      classes: { column: classes.cellContainer },
    },
    {
      columnKey: "total_co2e",
      columnId: "total_co2e",
      columnHeader: "CO2e (tonnes)",
      classes: { column: classes.cellContainer },
    },
  ];
  const getStatusColor = (item) => {
    if (item === "approved") {
      return (
        <Tooltip title="Approved" arrow>
          <Chip className={classes.signalApproved} />
        </Tooltip>
      );
    } else if (item === "submitted") {
      return (
        <Tooltip title="Submitted" arrow>
          <Chip className={classes.signalPending} />
        </Tooltip>
      );
    } else if (item === "audited") {
      return (
        <Tooltip title="Audited" arrow>
          <Chip className={classes.signalAudited} />
        </Tooltip>
      );
    } else if (item === "review") {
      return (
        <Tooltip title="Review" arrow>
          <Chip className={classes.signalReview} />
        </Tooltip>
      );
    } else if (item === "added") {
      return (
        <Tooltip title="Added" arrow>
          <Chip className={classes.signalAdded} />
        </Tooltip>
      );
    } else if (item === "assigned") {
      return (
        <Tooltip title="assigned" arrow>
          <Chip className={classes.signalPending} />
        </Tooltip>
      );
    } else if (item === "Awaiting approval") {
      return (
        <Tooltip title="Awaiting approval" arrow>
          <Chip className={classes.signalPending} />
        </Tooltip>
      );
    } else if (item === "In Progress") {
      return (
        <Tooltip title="In Progress" arrow>
          <Chip className={classes.signalPending} />
        </Tooltip>
      );
    } else if (item === "verified") {
      return (
        <Tooltip title="Verified" arrow>
          <Chip className={classes.signalVerified} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={item} arrow>
          <Chip className={classes.signalAdded} />
          {item}
        </Tooltip>
      );
    }
  };

  const parentData = {};
  const superParentData = {};
  reportEmissionTypeWIthScopeData.map((item) => {
    item.subItems.map((innerItem) => {
      innerItem.subItems.map((subInnerItem) => {
        parentData[subInnerItem.id] = innerItem.id;
        superParentData[subInnerItem.id] = item.id;
      });
    });
  });

  let aggreatedData = {};
  reportsData?.emissions?.map((item) => {
    let pushedData = item;
    let pushedcolumn = combustionSummaryColumns;
    if (parentData[item.type] === "waste_water") {
      pushedData = {
        ...item,
        type: item.type ? item.type.replace(/_/g, " ") : "",
        usage: `${item.usage}`,
        status: getStatusColor(item.status),
      };
      pushedcolumn = waterSummaryColumns;
    } else if (item.scope) {
      pushedData = {
        ...item,
        status: getStatusColor(item.status),
      };
      pushedcolumn = combustionSummaryColumns;
    }
    if (parentData[item.type] in aggreatedData) {
      aggreatedData[parentData[item.type]]["data"] =
        aggreatedData[parentData[item.type]]["data"].concat(pushedData);
    } else {
      aggreatedData[parentData[item.type]] = {};
      aggreatedData[parentData[item.type]]["data"] = [pushedData];
    }
    if (!("columns" in aggreatedData[parentData[item.type]]))
      aggreatedData[parentData[item.type]]["columns"] = pushedcolumn;
  });
  const reportMapper = {
    combined_report: "Combined Report (All modules)",
    offset_report: "Offset Report",
    materiality_report: "Materiality Report",
    supplier_report: "Supplier Report",
    sustainability_risk_report: "Sustainability Risk Report",
  };

  useEffect(() => {
    var availableReport = [];
    Object.entries(reportsBlobExist?.is_blob_exist || {}).map(
      ([key, value], index) => {
        if (!isBlobExist && value === true) setIsBlobExist(true);
        if (value === true) {
          // if (key === "combined_report") {
          //   availableReport.push(reportMapper[key]);
          //   availableReport.push("ESG");
          // }
          // else
          availableReport.push(reportMapper[key]);
        }
      }
    );
    setAvlReports(availableReport);
  }, [reportsBlobExist, dispatch]);

  const handleCheckboxChange = (event) => {
    const value = event.target.value;

    setChnReports((prevValues) => {
      if (prevValues.includes(value)) {
        // remove the value
        return prevValues.filter((item) => item !== value);
      } else {
        // add the value
        return [...prevValues, value];
      }
    });
  };

  const getDownloadWindow = () => (
    <Box>
      <Typography variant="body1" style={{ fontWeight: 300 }}>
        Choose which report you want to download:
      </Typography>
      <div
        style={{
          display: "inline-grid",
          margin: "10px 0px 16px 0px",
        }}
      >
        {avlReports.map((option, idx) => {
          return (
            <>
              <FormControlLabel
                key={idx}
                control={
                  <Checkbox
                    className={classes.selectCheckbox}
                    checked={chnReports?.includes(option) || false}
                    onChange={(e) => {
                      handleCheckboxChange(e);
                    }}
                    value={option}
                    sx={{
                      color: "#5A404E !important",
                      "&.Mui-checked": {
                        color: "#8C2148 !important",
                      },
                    }}
                  />
                }
                label={option}
                className={classes.label}
              />
            </>
          );
        })}
      </div>
      <div className={classes.buttonContainerReview}>
        <CeroButton
          className={classes.buttonFour}
          variant="outlined"
          onClick={() => setDownloadPopUp(false)}
          buttonText="Cancel"
        />
        <CeroButton
          className={classes.buttonPrimary}
          variant="contained"
          onClick={onDownloadReport}
          buttonText="download"
        />
      </div>
    </Box>
  );

  // const blobExist = reportsBlobExist.is_blob_exist === true;

  return (
    <DashboardLayout>
      <Container className={classes.container}>
        {reportsListStatus === STATUS.SUCCESS ? (
          <Fragment>
            <Box>
              <Box className={classes.buttonContainer}>
                <div className={classes.backContainer} onClick={navigateBack}>
                  <ArrowBackIosIcon />
                  Back
                </div>
                <div>
                  {isSustainabilityManager && (
                    <CeroButton
                      buttonText="Assign Report"
                      className={classes.buttonPrimary}
                      onClick={() => setOpenAssignReport(true)}
                      // disabled={isDeleteLoading}
                      disabled={readOnlyMode}
                    />
                  )}
                  {isOpenAssignReport && (
                    <AssignReport
                      isOpen={isOpenAssignReport}
                      onClose={handleDrawerClose}
                    />
                  )}
                  {(currentRole === "sustainability_manager" ||
                    currentRole === "proxy_sustainability_manager") && (
                    <CeroButton
                      buttonText={
                        isDeleteLoading ? "Deleting..." : "Delete Report"
                      }
                      className={classes.buttonPrimary}
                      onClick={onDeleteReport}
                      disabled={isDeleteLoading || readOnlyMode}
                    />
                  )}
                  <Tooltip
                    title={!isBlobExist ? "Report is being generated" : ""}
                    arrow
                    disableHoverListener={isBlobExist}
                  >
                    <span>
                      <CeroButton
                        buttonText="Download report"
                        endIcon={<DownloadForOfflineIcon />}
                        className={classes.buttonPrimary}
                        onClick={() => {
                          setDownloadPopUp(true);
                        }}
                        disabled={readOnlyMode || !isBlobExist}
                      />
                    </span>
                  </Tooltip>
                  {isBlobExist ? (
                    reportDetails?.block_chain_hash ? (
                      <CeroButton
                        buttonText="View nft"
                        endIcon={<ViewInArOutlinedIcon />}
                        className={classes.buttonPrimary}
                        onClick={() =>
                          window.open(
                            reportDetails?.block_chain_hash ||
                              `https://amoy.polygonscan.com/tx/${reportDetails?.transaction_hash}`,
                            "_blank"
                          )
                        }
                        disabled={readOnlyMode || !isBlobExist}
                      />
                    ) : (
                      <CeroButton
                        buttonText="Request Report NFT"
                        endIcon={<TokenIcon />}
                        className={classes.buttonPrimary}
                        onClick={requestNFT}
                        disabled={readOnlyMode || !isBlobExist}
                      />
                    )
                  ) : (
                    ""
                  )}
                </div>
              </Box>
              <Typography variant="h6" component="span">
                {`Report: ${reportDetails.name}`}
              </Typography>
            </Box>
            <Status reportDetails={reportDetails} />
            <div className={classes.exportIcons}>
              {/* <EmissionPDFExport
                emissionsArray={reportDetails.topics}
                selectedYear={selectedYear}
                facility={facilities}
                period={reportDetails?.period || null}
              /> */}
              <EmissionPDFExport
                emissionsArray={emissionTypes}
                selectedYear={selectedYear}
                facility={facilities}
                period={reportDetails?.period || null}
              />
            </div>
            {reportsDataStatus === STATUS.RUNNING ? (
              <CircularProgress />
            ) : reportsDataStatus === STATUS.SUCCESS ? (
              <>
                {reportsData?.emissions.length > 0 && (
                  <>
                    <Typography className={classes.title} paddingBottom={3}>
                      ESG Data
                    </Typography>
                    <ReportAccordion
                      approvalData={reportsData?.emissions}
                      aggreatedData={aggreatedData}
                      emissionData={filteredData}
                      emissionDataStatus={reportsDataStatus}
                      onSelectData={onSelectData}
                      isaudited={isaudited}
                      reportSignals={reportsData.category}
                      topicSignals={reportsData.sub_category_list}
                      subTopicSignals={reportsData.topic_type_status}
                    />
                  </>
                )}
                {reportsData.offset_approval_status_list?.length > 0 &&
                  canAbleSeeOffset && (
                    <>
                      <Typography className={classes.title} paddingBottom={3}>
                        Carbon Offset
                      </Typography>
                      <CeroTable
                        columns={TableColumns}
                        data={getCarbonOffsetList}
                        hasMore={false}
                        loading={false}
                        onSelectRow={onSelectCarbonOffsetData}
                      />
                    </>
                  )}
                {isSustainabilityManager &&
                  reportsData.materiality_survey_result?.length > 0 && (
                    <>
                      <Typography className={classes.title} paddingBottom={3}>
                        Materiality Assessment
                      </Typography>
                      <CeroTable
                        columns={MaterialityColumns}
                        data={materialityData(
                          reportsData.materiality_survey_result
                        )}
                        hasMore={false}
                        loading={false}
                        onSelectRow={() => {}}
                      />
                    </>
                  )}
                {isSustainabilityManager &&
                  reportsData.supplier_survey_result?.length > 0 && (
                    <>
                      <Typography className={classes.title} paddingBottom={3}>
                        Supplier Assessment
                      </Typography>
                      <CeroTable
                        columns={SupplierColumns}
                        data={supplierData(reportsData.supplier_survey_result)}
                        hasMore={false}
                        loading={false}
                        onSelectRow={() => {}}
                      />
                    </>
                  )}
                {isSustainabilityManager &&
                  reportsData.risk_survey_result?.length > 0 && (
                    <>
                      <Typography className={classes.title} paddingBottom={3}>
                        Risk Assessment
                      </Typography>
                      <CeroTable
                        columns={RiskAssessmentColumns}
                        data={riskAssessmentData(
                          reportsData.risk_survey_result
                        )}
                        hasMore={false}
                        loading={false}
                        onSelectRow={() => {}}
                      />
                    </>
                  )}
                {isEmissionsEmpty && isOffsetEmpty && isSurveyEmpty && (
                  <Typography className={classes.title} paddingBottom={3}>
                    No Data to Display
                  </Typography>
                )}
              </>
            ) : (
              "Something went wrong. Please try again later."
            )}
          </Fragment>
        ) : (
          <Box className={classes.loader}>
            <Typography variant="h7" component="span">
              {reportsListStatus === STATUS.RUNNING ? (
                <CircularProgress />
              ) : reportsListStatus === STATUS.ERROR ? (
                "Something went wrong. Please try again later"
              ) : (
                ""
              )}
            </Typography>
          </Box>
        )}
        <CeroPopUp
          primaryPopUp={{
            open: downloadPopUp,
            onClose: () => setDownloadPopUp(false),
            content: getDownloadWindow(),
            header: { title: "Download Report" },
          }}
          classes={{ dialog: classes.dialog }}
        />
      </Container>
    </DashboardLayout>
  );
};

export default ReportDetails;
